import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";
import {listMethods} from '../utils/utilsInterface';

import * as PD from '../classes/pdStyle';

class ListMethods extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Methods: [],
            errorMessage: ''
        };

        this.dsd = new dsd();
    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){
   if (!isEqual(this.props, prevProps)){
       this.setup();
   }
}

loadData(filters){

    const onLoad = function(arr){
        this.setState({ Methods: arr, renderState: 'loaded' });
        if (this.state.onLoad){ this.state.onLoad(arr.length); }
    }.bind(this);

    const onError = function(e){
        let errorMessage = e.message;
        if (e.response && e.response.data && e.response.data.message){
            errorMessage = e.response.data.message;
        }
        this.setState({ renderState: 'failed', errorMessage: errorMessage });
    }.bind(this);

    listMethods(this.dsd, filters, onLoad, onError);
}


setup(){

    let StateChange = {
        filters: {},
        columns: {},
        onLoad: null
    }

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.setState(StateChange);
    this.loadData(StateChange.filters);
        
}



    included(Method) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {

        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    {this.state.errorMessage || 'A problem has occurred'}
                </PD.ErrorBox>
            )
        }

        if (this.state.renderState === 'loaded') {
            let arrMethods = this.state.Methods;
            if (isArray(arrMethods)){
                if (arrMethods.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    <PD.Th>Action</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrMethods.map(
                                    (Method, pos) => 
                                    {
                                        if (this.included(Method)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={"/method/" + Method._id} > {Method.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Method.action){
                                                                        return Method.action;
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Method.description, 400)}</PD.MdPresent>
                                                        </PD.Td>
                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListMethods_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListMethods {...props} navigation={navigation} location={location} params={params} />;
  }
